export default __webpack_public_path__ + "static/media/1493.a83a4cbb.png";